import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AssignCardToUser, GetFreeCards } from '../../../../../reduxToolkit/Cards/CardsApi';
import {GetEmployeeDetailsByUserId} from "../../../../../reduxToolkit/Employee/EmployeeApi";
import {useParams} from "react-router-dom";

const AssignFreeCardApp = ({ cardsAssign, setCardsAssign, show, componentAction, onHide, userData }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { getFreeCards } = useSelector((state) => state.CardsSlice);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [selectCardToAssign, setSelectCardToAssign] = useState([]);

    useEffect(() => {
        setSelectCardToAssign([]);
        if (show) {
            dispatch(GetFreeCards());
        }
    }, [show]);

    //function to handle confirm
    const handleAssign = () => {
        if (componentAction === 'update') {
            const body = {
                cardIds: selectCardToAssign,
                userId: userData.id,
            };
            dispatch(AssignCardToUser(body)).then(
                ({
                    payload: {
                        data: { success },
                    },
                }) => {
                    if (success === true) {
                        dispatch(GetEmployeeDetailsByUserId(id)).then(
                            ({
                                 payload: {
                                     data: { data },
                                 },
                             }) => {
                                setCardsAssign(data?.cards);
                                reset();
                            },
                        );
                    }
                },
            );
        } else {
            let aux = getFreeCards.filter(item => selectCardToAssign.includes(item.id));
            setCardsAssign([...cardsAssign, ...aux]);
            reset();
        }
    };

    const reset = () =>{
        setSelectCardToAssign([]);
        setIsAllChecked(false);
        onHide();
    }

    const closeModal = () => {
        setCardsAssign(cardsAssign);
        onHide();
    };

    return {
        getFreeCards,
        selectCardToAssign,
        setSelectCardToAssign,
        isAllChecked,
        setIsAllChecked,
        handleAssign: (e) => handleAssign(e),
        closeModal: (e) => closeModal(e)
    }

}

export default AssignFreeCardApp;
